export const SET_FIELD_ERROR = 'SET_FIELD_ERROR';
export const UNSET_FIELD_ERROR = 'UNSET_FIELD_ERROR';
export const SET_ERRORS = 'SET_ERRORS';
export const SET_FIELD = 'SET_FIELD';
export const SET_IMAGES = 'SET_IMAGES';
export const INCREASE_STEP = 'INCREASE_STEP';
export const SET_STEP = 'SET_STEP';
export const START_LOADING = 'START_LOADING';
export const STOP_LOADING = 'STOP_LOADING';

const createProjectFormReducer = (state, action) => {
  switch (action.type) {
    // Set error for x field.
    case SET_FIELD_ERROR: {
      return {
        ...state,
        errors: {
          ...state.errors,
          [action.payload.fieldName]: action.payload.errorMessage,
        },
      };
    }

    // Unset error for x field.
    case UNSET_FIELD_ERROR: {
      return {
        ...state,
        errors: {
          ...state.errors,
          [action.payload.fieldName]: undefined,
        },
      };
    }

    // Update errors object.
    case SET_ERRORS: {
      return {
        ...state,
        errors: {
          ...state.errors,
          ...action.payload.errors,
        },
      };
    }

    // Set value for x field.
    case SET_FIELD: {
      return {
        ...state,
        data: {
          ...state.data,
          [action.payload.fieldName]: action.payload.value,
        },
      };
    }

    case INCREASE_STEP: {
      return {
        ...state,
        currentStep: state.currentStep + 1,
      };
    }

    case SET_STEP: {
      return {
        ...state,
        currentStep: action.payload.step,
      };
    }

    case START_LOADING: {
      return {
        ...state,
        loading: true,
      };
    }

    case STOP_LOADING: {
      return {
        ...state,
        loading: false,
      };
    }

    default: {
      return state;
    }
  }
};

export default createProjectFormReducer;
